export default "//yastatic.net/s3/distribution/pythia/frontend/_/f4f1a6e3995a7cd7b6b314304633bf80.png";